<template>
  <div>
    <header-navigation></header-navigation>
    <div class="page page-404">
      <template v-for="(block, index) in content">
        <component
          :is="block.acf_fc_layout"
          v-bind:acf="block[block.acf_fc_layout]"
          v-bind:data="block[block.acf_fc_layout]"
          :key="index"
        ></component>
      </template>
    </div>
    <footer>
      <nav class="company-pages px-3 px-md-0">
        <div class="container">
          <div class="">
            <footer-navigation
              v-bind:category="'quick-links'"
            ></footer-navigation>
          </div>
          <hr class="d-none d-md-block" />

          <div class="row">
            <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
              <footer-navigation
                v-bind:category="'useful-links'"
              ></footer-navigation>
            </div>

            <div class="col-lg-4">
              <social-media></social-media>
              <div class="copyright-disclaimers d-none d-md-block">
                <p><span>© ResMed</span> {{ $getTranslation("All rights reserved.", $route.params.region) }}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </footer>
    <modal-video></modal-video>
  </div>
</template>

<script>
// import jsonData from "./assets/data.json";
// import group from "./components/navigation/group.vue";
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import socialMedia from "./components/navigation/social-media.vue";

export default {
  components: { headerNavigation, footerNavigation, socialMedia },
  data() {
    return {
      content: {},
      animation: {},
      glossary: {},
    };
  },
  name: "App",
  created() {},
  async mounted() {
    console.log(this.$route.params);
    const data = await axios.get(
      `${process.env.VUE_APP_API_ENDPOINT}/wp-json/resmed/v1/get-page-by-slug`,
      {
        params: {
          locale: this.$route.params.region || "en-us",
          slug: `404-page-sleep-apnea`,
        },
      }
    );
    this.content = data.data.fields;
    this.animation = data.data.animation
      ? {
          ...data.data.animation,
          animation: JSON.parse(data.data.animation.animation),
        }
      : {};
    this.glossary = data.data.glossary ? data.data.glossary : {};
  },
  computed: {
    myFields: () => JSON.parse(JSON.stringify(this.content.fields)),
  },
};
</script>

<style>
.for-professionals {
  padding: 7rem 0 1rem 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
